import type { TableData } from '@app/types/table'
import type { ManagingSubtypesDataSource } from '@app/pages/ManagingSubtypesPage/types'
import type { ResponseDto } from '@app/api/dtos'
import type { MonitoringsTypesWithSubtypesDto } from '@app/api/routes/monitorings/dtos'

export const adaptManagingSubtypesTableData = (
  monitoringsTypesWithSubtypesResponse: ResponseDto<MonitoringsTypesWithSubtypesDto>
): TableData<ManagingSubtypesDataSource> => {
  const { count, results: monitoringsTypesWithSubtypes } = monitoringsTypesWithSubtypesResponse

  const dataSource: ManagingSubtypesDataSource[] = monitoringsTypesWithSubtypes.map(dto => ({
    key: dto.id,
    monitoringType: dto?.monitoringType?.name ?? null,
    subtypes: dto?.monitoringSubtypes ?? null
  }))

  return { count, dataSource }
}
